import { SlashForwardBoxIcon } from './SlashForwardBoxIcon';

/**
 * author: Michael Irigoyen
 * id D6A5CF49-38A9-4911-ACAC-FF9A09BBEC76
 * name slash-forward-box
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/slash-forward-box.svg
 * tags
 * - Math 
 */
export const DivideBoxIcon = SlashForwardBoxIcon;
export default DivideBoxIcon